import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface MarkDoneDialogProps {
  open: boolean;
  userName: string;
  onClose: () => void;
  onConfirm: (comment: string, speedAdjusted: boolean) => void;
}

export function MarkDoneDialog({ open, userName, onClose, onConfirm }: MarkDoneDialogProps) {
  const { t } = useTranslation();
  const [comment, setComment] = useState("");
  const [speedAdjusted, setSpeedAdjusted] = useState(false);

  const handleConfirm = () => {
    onConfirm(comment.trim(), speedAdjusted);
    setComment("");
    setSpeedAdjusted(false);
  };

  const handleClose = () => {
    setComment("");
    setSpeedAdjusted(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("speedLimitReport.markDoneTitle")}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {t("speedLimitReport.markDoneProcessor")}: <strong>{userName}</strong>
        </Typography>
        <TextField
          label={t("speedLimitReport.markDoneCommentLabel")}
          multiline
          rows={3}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          fullWidth
          autoFocus
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={speedAdjusted}
              onChange={(e) => setSpeedAdjusted(e.target.checked)}
            />
          }
          label={t("speedLimitReport.markDoneSpeedAdjusted")}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t("speedLimitReport.markDoneCancel")}</Button>
        <Button onClick={handleConfirm} variant="contained">
          {t("speedLimitReport.markDoneConfirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
